'use strict';
import { maxHeight } from "../functions.js";

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');
  const btnToggleSystem = document.querySelectorAll('.js-payments-more-btn');
  const systems = document.querySelectorAll('.js-payments');
  if (btnToggleSystem) {
    btnToggleSystem.forEach((item) => {
      const visibleText = item.getAttribute('data-text-visible');
      const hiddenText = item.getAttribute('data-text-hidden');

      item.addEventListener('click', () => {
        const attrHidden = item.hasAttribute('data-hidden');
        if (attrHidden) {
          item.removeAttribute('data-hidden');
          item.innerHTML = hiddenText;
        } else {
          item.setAttribute('data-hidden', '');
          item.innerHTML = visibleText;
        }

        const systemHidden = item.parentElement.parentElement.querySelectorAll('.js-payments-item[data-visible="hidden"]');
        systemHidden.forEach((el) => el.classList.toggle('hidden'));

        const height = maxHeight('.js-payments-row');
        systems.forEach((el) => {
          el.parentElement.style.height = height + 'px';
        });
      });
    });
  }

  const versusContent = document.querySelector('.versus__compare');
  const versusPopup = document.querySelector('.popup-banner');
  const versusAside = document.querySelector('.main__aside--versus');

  if (versusContent) {
    window.addEventListener('scroll', () => {
      if (versusContent.getBoundingClientRect().top < 0) {
        versusPopup.classList.add('popup-banner--active');
        versusAside.style.top = versusPopup.offsetHeight + header.offsetHeight + 16 + 'px';
      } else {
        versusPopup.classList.remove('popup-banner--active');
        versusAside.removeAttribute('style');
      }
    });
  }

  const versusList = document.querySelector('.versus-aside__list--no-padding');
  if (versusList) {
    window.addEventListener('resize', () => {
      if (window.outerWidth >= 992) {
        buttonTableContents.classList.remove('versus-aside__button--opened');
        versusList.removeAttribute('style');
      }
    });
  }

  const buttonTableContents = document.querySelector('.versus-aside__button');
  if (buttonTableContents) {
    buttonTableContents.addEventListener('click', () => {
      if (document.body.clientWidth < 992) {
        buttonTableContents.classList.toggle('versus-aside__button--opened');
        slideToggle(buttonTableContents.nextElementSibling);
      }
    });
  }

  const linksTableContents = document.querySelectorAll('.versus-aside__link');
  if (linksTableContents) {
    linksTableContents.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const link = item.getAttribute('href');
        const blockID = link.substring(link.indexOf('#'));
        const elID = document.querySelector(blockID);
        let topOffset = header.offsetHeight + 12;
        const bannerHeight = versusPopup.offsetHeight;
        const elementPosition = elID.getBoundingClientRect().top;

        if (document.body.clientWidth >= 992) {
          topOffset += bannerHeight;
        }

        const offsetPosition = elementPosition - topOffset;

        window.scrollBy({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    });
  }

  const advantagesContents = document.querySelectorAll('.advantages__content--versus .advantages__list--check');
  if (advantagesContents && window.outerWidth >= 768) {
    let maxHeight = 0;
    advantagesContents.forEach((list) => {
      if (maxHeight < list.offsetHeight) {
        maxHeight = list.offsetHeight;
      }
    });

    advantagesContents.forEach((list) => {
      list.style.height = maxHeight + 'px';
    });
  }
});
